export default __webpack_public_path__ + "static/media/Newspaper-Publication-of-Postal-Ballot-Notice-21-10-2026.1d5ee5f0.pdf";